var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#icon-hp';
                    var viewUrl = 'sprite.svg#view-icon-hp';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 66 60',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };